import { ManagementType, SortConfig } from "types/common";
import { useEffect, useState } from "react";
import {
  TABLE_HEADER_PATIENT_CLINIC_ASSISTANT,
  TABLE_HEADER_PATIENT_CLINIC_TEAM_ASSISTANT_AND_LEAD,
  TABLE_HEADER_PATIENT_CLINIC_TEAM_LEAD,
  TABLE_HEADER_PATIENT_CLINIC_TEAM_MEMBER,
  TABLE_HEADER_USERS_CLINIC_ADMIN,
} from "constants/dashboard";
import { useAppSelector } from "hooks/reduxHooks";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { USER_GROUPS } from "constants/roles";
import { TableHeaderButton } from "../../../PatientOverview/components/Athlete/TableHeaderButton";

type Props = {
  onClick: (sortBy: string) => void;
  onClickClinicianPatients: (sortBy: string) => void;
  onClickClinicPatients: (sortBy: string) => void;
  sortConfig: SortConfig;
  managementType?: ManagementType;
};

export const ManagementTableHeader = ({
  onClick,
  onClickClinicianPatients,
  onClickClinicPatients,
  sortConfig,
  managementType,
}: Props) => {
  const currentClinician: any = useAppSelector(selectCurrentClinician);
  const [currentUserRolesHeader] = useState(currentClinician?.role);
  const [currentClinicianRoleHeader, setCurrentClinicianRoleHeader] =
    useState<any>();

  useEffect(() => {
    if (currentUserRolesHeader) {
      if (!managementType) {
        return;
      }
      if (managementType == ManagementType.USER) {
        setCurrentClinicianRoleHeader(TABLE_HEADER_USERS_CLINIC_ADMIN);
      } else if (managementType == ManagementType.PATIENT) {
        if (
          currentUserRolesHeader.includes(USER_GROUPS.CLINIC_TEAM_LEAD) &&
          currentUserRolesHeader.includes(USER_GROUPS.CLINIC_ASSISTANT)
        ) {
          setCurrentClinicianRoleHeader(
            TABLE_HEADER_PATIENT_CLINIC_TEAM_ASSISTANT_AND_LEAD
          );
        } else if (
          currentUserRolesHeader.includes(USER_GROUPS.CLINIC_ASSISTANT)
        ) {
          setCurrentClinicianRoleHeader(TABLE_HEADER_PATIENT_CLINIC_ASSISTANT);
        } else {
          setCurrentClinicianRoleHeader(TABLE_HEADER_PATIENT_CLINIC_TEAM_LEAD);
        }
      } else {
        setCurrentClinicianRoleHeader(TABLE_HEADER_PATIENT_CLINIC_TEAM_MEMBER);
      }
    }
  }, []);

  return (
    <div>
      {currentClinicianRoleHeader && (
        <div
          className="w-full flex items-center text-grayDark text-[10px] mb-2.5 "
          style={{
            justifyContent:
              managementType == ManagementType.USER
                ? "space-between"
                : "normal",
          }}
        >
          {currentClinicianRoleHeader.map((item: any) => {
            const handleClick = () => {
              onClick(item.sortBy);
            };
            const handleClickClinicianPatients = () => {
              onClickClinicianPatients(item.sortBy);
            };
            const handleClickClinicPatients = () => {
              onClickClinicPatients(item.sortBy);
            };

            const handleClickFunction = () => {
              if (managementType === ManagementType.PATIENT_CARE) {
                handleClickClinicianPatients();
              } else if (managementType === ManagementType.PATIENT) {
                handleClickClinicPatients();
              } else {
                handleClick();
              }
            };

            return (
              <div
                key={item.title}
                className="space-x-1 text-left  relative"
                style={{ width: item.width, marginLeft: item?.marginLeft || 0 }}
              >
                {item.title && (
                  <TableHeaderButton
                    handleClick={handleClickFunction}
                    item={item}
                    sortConfig={sortConfig}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
